/**
 * NapiHami verziókövetés
 * Szemantikus verziószámozás (SemVer): MAJOR.MINOR.PATCH
 * 
 * MAJOR: Nem visszafelé kompatibilis változások
 * MINOR: Új funkciók, visszafelé kompatibilis módon
 * PATCH: Hibajavítások, visszafelé kompatibilis módon
 */

export const APP_VERSION = "3.20.0";

export const VERSION_INFO = {
  version: APP_VERSION,
  releaseDate: "2026-10-21",
  codename: "Dodi",
};
